export default __webpack_public_path__ + "static/media/4338.2945bb03.png";